module.exports = (__webpack_require__(0))(65);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/collections/FolderCollection.js from dll-reference girder_lib
// module id = 134
// module chunks = 0